import { ProposalOptionNameDefault } from './proposalOptionNameDefaults.models';

interface ProposalOptionNameDefaultsState {
  ids: string[];
  entities: Record<string, ProposalOptionNameDefault>;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
}

type Action =
  | {
      type: 'SET_LOADING_STATE';
      payload: Pick<ProposalOptionNameDefaultsState, 'isLoading' | 'isLoaded'>;
    }
  | { type: 'FETCH_OPTION_NAMES' }
  | {
      type: 'FETCH_OPTION_NAMES_SUCCESS';
      payload: ProposalOptionNameDefault[];
    }
  | { type: 'FETCH_OPTION_NAMES_FAILURE'; payload: { error: string } };

export const initialState: ProposalOptionNameDefaultsState = {
  ids: [],
  entities: {},
  isLoading: true,
  isLoaded: false,
  error: null,
};

export const proposalOptionNameDefaultsReducer = (
  state: ProposalOptionNameDefaultsState,
  action: Action
): ProposalOptionNameDefaultsState => {
  switch (action.type) {
    case 'SET_LOADING_STATE':
      return {
        ...state,
        ...action.payload,
        error: null,
      };

    case 'FETCH_OPTION_NAMES':
      return {
        ...state,
        isLoading: true,
        isLoaded: state.isLoaded || !!state.ids.length,
        error: null,
      };
    case 'FETCH_OPTION_NAMES_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ids: [...new Set(action.payload.map((a) => a.optionNameId))],
        entities: action.payload.reduce(
          (prev, curr) => ({ ...prev, [curr.optionNameId]: curr }),
          {}
        ),
      };
    case 'FETCH_OPTION_NAMES_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload.error,
      };

    default:
      return state;
  }
};
